<template>
  <article>
    <el-table
      ref="dataTable"
      :data="lists"
      highlight-current-row
      v-loading="listLoading"
      style="width: 100%;"
      height="600"
    >
      <!-- 优雅版：v-if 放外层，key 包含 index -->
      <template v-for="(col, index) in tableColumns" v-if="col.isShow">
        <el-table-column
          :key="`${col.columnName}-${index}`"
          :prop="col.columnName"
          :label="col.columnTitle"
          align="center"
        >
          <template slot="header" slot-scope="scope">
            <span>
              <i
                v-if="index === 0"
                class="el-icon-setting"
                style="cursor:pointer; margin-right:6px"
                @click="isShowColumn = true"
              ></i>
              {{ col.columnTitle }}
            </span>
          </template>
        </el-table-column>
      </template>
    </el-table>

    <TableColumnSetting
      :visible.sync="isShowColumn"
      :column-list.sync="tableColumns"
      :default-columns="defaultColumns"
      :storage-key="`${$options.name}_table_columns`"
    />

    <el-pagination
      layout="total, sizes, pager, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-size="filters.l"
      :page-sizes="[20, 50, 80, 100]"
      :total="filters.total"
      :current-page="filters.p"
      class="tac mt-36 pb-36"
    />
  </article>
</template>

<script>
import util from '../../../script/util'
import mixinList from '../../../mixins/list'
import {adBase} from '../../../api/api'

export default {
  name: 'adBase',
  mixins: [mixinList],
  data () {
    return {
      lists: [],
      listLoading: false,
      isShowColumn: false,
      filters: { p: 1, l: 20, total: 0 },
      defaultColumns: [
        { columnName: 'date', columnTitle: '日期', isShow: true },
        { columnName: 'new_count', columnTitle: '新增用户', isShow: true },
        { columnName: 'user_upload_count', columnTitle: '报单用户数', isShow: true },
        { columnName: 'ad_upload_count', columnTitle: '报单广告数', isShow: true },
        { columnName: 'upload_ocount', columnTitle: '报单订单数', isShow: true },
        { columnName: 'upload_payment', columnTitle: '报单金额', isShow: true },
        { columnName: 'upload_commission', columnTitle: '报单佣金', isShow: true },
        { columnName: 'invalid_ocount', columnTitle: '丢单订单数', isShow: true },
        { columnName: 'invalid_payment', columnTitle: '丢单金额', isShow: true },
        { columnName: 'apply_ocount', columnTitle: '可提现订单数', isShow: true },
        { columnName: 'apply_commission', columnTitle: '可提现金额', isShow: true },
        { columnName: 'exchange_commission', columnTitle: '打款金额', isShow: true }
      ],
      tableColumns: []
    }
  },
  methods: {
    handleSizeChange (val) {
      this.filters.l = val
      this.getList()
    },
    handleCurrentChange (val) {
      this.filters.p = val
      this.getList()
    },
    getList () {
      let params = { p: this.filters.p, l: this.filters.l }
      this.listLoading = true
      adBase(params).then(res => {
        let data = res.data || { c: -1 }
        if (!data.c) {
          this.lists = data.d.lists
          this.filters.total = data.d.total
        } else {
          this.$notify({
            title: '失败',
            message: util.getErrorMsg(data.c),
            type: 'error'
          })
        }
        this.listLoading = false
      }).catch(() => {
        this.listLoading = false
        this.$notify({
          title: '失败',
          message: '服务器出错了',
          type: 'error'
        })
      })
    },
    handleColumnChange (newList) {
      this.tableColumns = [...newList] // 优雅赋值
      this.$nextTick(() => {
        this.$refs.dataTable.doLayout()
      })
    }
  },
  mounted () {
    this.getList()
  },
  updated () {
    this.$nextTick(() => {
      this.$refs['dataTable'].doLayout()
      this.$refs['dataTable'].bodyWrapper.scrollTop = 0
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/page/module/ad/adBase.vue